export const FLOOR_PLAN_AUTOSAVE_KEY = 'panelforge:floor-plan:last-project:v1';

export function readAutosavedProject(): string | null {
  try {
    return window.localStorage.getItem(FLOOR_PLAN_AUTOSAVE_KEY);
  } catch (error) {
    console.warn('Unable to read floor-plan autosave.', error);
    return null;
  }
}

export function writeAutosavedProject(json: string): void {
  try {
    window.localStorage.setItem(FLOOR_PLAN_AUTOSAVE_KEY, json);
  } catch (error) {
    console.warn('Unable to save floor-plan autosave.', error);
  }
}

export function removeAutosavedProject(): void {
  try {
    window.localStorage.removeItem(FLOOR_PLAN_AUTOSAVE_KEY);
  } catch (error) {
    console.warn('Unable to remove floor-plan autosave.', error);
  }
}
